import { AnalyticsService } from "./AnalyticsService.js";
import { DeviceService } from "./DeviceService.js";
import { HistoryService } from "./HistoryService.js";
import { LoggingService } from "./LoggingService.js";
import { MessageApiService } from "./MessageApiService.js";
import { PostApiService } from "./PostApiService.js";
import { SessionApiService } from "./SessionApiService.js";
import { SheetService } from "./SheetService.js";
import { UserApiService } from "./UserApiService.js";
import { VolumeService } from "./VolumeService.js";

// Initialize services once
const services = new Map();

services.set("AnalyticsService", new AnalyticsService());
services.set("DeviceService", new DeviceService());
services.set("HistoryService", new HistoryService());
services.set("SheetService", new SheetService());
services.set("VolumeService", new VolumeService());

// At some point this will get out of control and we will need dependency
// injection, but this works for now.s
const loggingService = new LoggingService();
services.set("LoggingService", loggingService);
services.set("MessageApiService", new MessageApiService(loggingService));
services.set("PostApiService", new PostApiService(loggingService));
services.set("SessionApiService", new SessionApiService(loggingService));
services.set("UserApiService", new UserApiService(loggingService));

export { services };
